import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cuándo recibo el ebook?',
  a: 'Inmediatamente después del pago, vas a poder acceder y descargarlo.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. Está diseñado para personas que empiezan desde cero.'
}, {
  q: '¿Es solo para mujeres?',
  a: 'No. Es para cualquier persona que quiera mejorar sus hábitos, su físico y su mentalidad.'
}, {
  q: '¿En qué formato viene?',
  a: 'En PDF digital, para que lo uses desde tu celular, tablet o computadora.'
}, {
  q: '¿Cuánto tiempo me va a llevar por día?',
  a: 'Son hábitos simples que podés adaptar a tu rutina diaria sin complicarte.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-28 px-4 bg-warm" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-63">
          <h2 className="text-3xl md:text-4xl font-bold text-primary font-serif" data-id="element-64">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-65">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-xl border border-border overflow-hidden shadow-sm" data-id="element-66">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-67">
                <span className="font-bold text-primary pr-4" data-id="element-68">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="shrink-0 text-nude-dark" data-id="element-69">
                  <ChevronDown className="w-5 h-5" data-id="element-70" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-71">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-72">
                    <div className="px-6 pb-6 text-secondary border-t border-border/50 pt-4" data-id="element-73">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}